import styled from 'styled-components'
import { ASSET_PREFIX } from '~/constants/env'

export const StyledShareWrapper = styled.div`
  .exchange-header-wrap {
    background: white;
  }

  .footer-wrap {
    background: white;
    a {
      text-decoration: none;
    }
  }
  .lon-share {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    padding: 100px 30px 100px 30px;
    background-image: url(${ASSET_PREFIX + '/images/lon/tokenlon-bg.svg'});
    background-repeat: no-repeat;
    max-width: 960px;
    width: 100vw;
    margin: 0 auto;
    .share-card {
      width: 305px;
      height: 425px;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;

      .code-wrap {
        text-align: center;
        position: absolute;
        top: 130px;
        .title {
          font-size: 13px;
          line-height: 22px;
          color: rgba(255, 255, 255, 0.5);
          margin: 0;
        }
        .code {
          font-size: 48px;
          line-height: 70px;
          letter-spacing: 5px;
          margin: 0;
          padding-left: 5px;
          color: #d0c9cd;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
            'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
            'Helvetica Neue', sans-serif;
        }

        &.tft {
          .title {
            color: rgba(255, 255, 255, 0.7);
          }
          .code {
            color: #d0c9cd;
          }
        }
      }

      .no-invitation {
        font-size: 17px;
        line-height: 25px;
        color: #fafbfc;
        opacity: 0.5;
        position: absolute;
        top: 340px;
      }

      button {
        line-height: 45px;
        border: 0;
        font-size: 17px;
        text-align: center;
        background: #5f5fab;
        color: white;
        border-radius: 25px;
        width: 215px;
        outline: none;
        position: absolute;
        top: 340px;
        cursor: pointer;

        &.tft {
          background: #ebe9f9;
          color: #55546c;
        }
      }
    }

    .desc {
      font-size: 13px;
      line-height: 20px;
      color: #777a8c;
      margin: 2px 0;
      width: 335px;
      text-align: center;

      a {
        text-decoration: none;
        color: white;
        margin-left: 4px;
      }
    }

    #canvas {
      position: fixed;
      left: 0;
      top: 0;
      width: 1245px;
      height: 1800px;
      background-color: #20203d;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      visibility: hidden;

      .share-card {
        width: 915px;
        height: 1275px;
        margin-bottom: 96px;

        img {
          width: 1000px;
          height: 1300px;
          object-fit: cover;
        }
        .code-wrap {
          top: 390px;
          .title {
            font-size: 39px;
            line-height: 66px;
          }
          .code {
            font-size: 144px;
            line-height: 210px;
            letter-spacing: 20px;
            padding-left: 20px;
            color: #d0c9cd;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
              'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
              'Helvetica Neue', sans-serif;
          }
        }
        .card-footer {
          position: absolute;
          top: 990px;
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: space-between;
          width: 720px;
          padding: 0 100px;
          box-sizing: content-box;
          p {
            font-size: 39px;
            line-height: 48px;
            color: #ffffff;
            max-width: 500px;
            line-break: anywhere;
            word-break: break-all;
          }

          .qrcode-wrap {
            padding: 8px 8px 0px 8px;
            background: white;
            border-radius: 2px;
          }
        }
      }

      .desc {
        text-align: left;
        font-size: 36px;
        line-height: 50px;
        margin: 6px 0;
        width: 915px;
      }
    }
  }
  .sharing-modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(50, 56, 72, 0.7);
    left: 0;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;

    .button-container {
      background: #373756;
      width: 375px;
      height: 220px;
      border-radius: 8px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .row {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-around;
        padding-bottom: 15px;
        cursor: pointer;
        width: 80%;

        .col {
          display: flex;
          flex-flow: column nowrap;
          align-items: center;
          justify-content: center;

          > div {
            width: 65px;
            height: 65px;
            box-sizing: border-box;
            background: #e3e1f0;
            border-radius: 50%;
            padding: 16.5px;
            cursor: pointer;
            img {
              width: 32px;
              height: 32px;
            }
          }

          span {
            font-size: 15px;
            line-height: 22px;
            color: ${({ theme }) => theme.colors.textPlaceholder};
            margin-top: 14px;
          }
        }
      }

      .close-o {
        display: inline-block;
        position: absolute;
        right: -30px;
        top: -30px;
        cursor: pointer;
      }

      .cancel {
        display: none;
      }
    }
  }
  @media screen and (max-width: 960px) {
    .lon-wrap {
      .exchange-header-wrap {
        display: none;
      }

      .footer-wrap {
        display: none;
      }

      .lon-share {
        .share-card {
          .code-wrap {
            .code {
              letter-spacing: 10px;
              padding-left: 10px;
            }
          }
        }
      }
    }
    .sharing-modal {
      display: block;
      .button-container {
        border-radius: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        padding: 25px;
        padding-bottom: 5px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        flex-flow: column nowrap;
        box-sizing: border-box;

        .close-o {
          display: none;
        }

        .cancel {
          display: block;
          width: 100%;
        }

        .row {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: space-around;
          padding-bottom: 15px;
          cursor: pointer;

          .col {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;

            > div {
              width: 65px;
              height: 65px;
              box-sizing: border-box;
              background: #e3e1f0;
              border-radius: 50%;
              padding: 16.5px;
              img {
                width: 32px;
                height: 32px;
              }
            }

            span {
              font-size: 15px;
              line-height: 22px;
              color: ${({ theme }) => theme.colors.textPlaceholder};
              margin-top: 14px;
            }
          }
        }

        .cancel {
          font-size: 15px;
          line-height: 22px;
          text-align: center;
          color: ${({ theme }) => theme.colors.textPlaceholder};
          border-top: 0.5px solid rgba(227, 225, 240, 0.1);
          padding: 15px;
          margin: 0;
        }
      }
    }
  }
`
